export default "__VITE_ASSET__ca1ff693__"